/* ============================================================
   MAWJ — Lander v4 engine
   - Bundle / shape / gift-box selection -> live total
   - Builds a rich WhatsApp message and applies it to every
     wa.me link on the page (primary CTA, sticky bar, hero CTA).
   - Contact tracking stays with the global mawj-contact-tracking.js
     (the links are real <a href="wa.me/..."> so it fires once/session).
   - Reveal-on-scroll for [data-rise].
   ============================================================ */
(function () {
  'use strict';

  var BASE = 125;        // first piece
  var SECOND_ADD = 115;  // second piece (= save 10 -> 240 for two)
  var BOX_EACH = 25;     // luxury gift box, per piece

  function init() {
    initReveal();
    var offer = document.querySelector('.l4-offer');
    if (!offer) return;
    initOffer(offer);
  }

  /* reveal on scroll — add .reveal so the hidden state only applies when JS runs */
  function initReveal() {
    var roots = document.querySelectorAll('.l4');
    var els = document.querySelectorAll('.l4 [data-rise]');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (e) { e.classList.add('is-in'); });
      return;
    }
    roots.forEach(function (r) { r.classList.add('reveal'); });
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  function initOffer(offer) {
    var phone   = offer.getAttribute('data-phone')   || '971503395366';
    var product = offer.getAttribute('data-product') || 'كريستال موج';

    var bundles = offer.querySelectorAll('.js-bundle');
    var shapes  = offer.querySelectorAll('.js-shape');
    var boxEl   = offer.querySelector('.js-box');
    var totalEl = offer.querySelector('.js-total');
    var waLinks = document.querySelectorAll('.js-wa');     // page-wide
    var priceEls = document.querySelectorAll('.js-price'); // page-wide (sticky)

    var state = { qty: 1, shape: '', box: false };

    function total() {
      return BASE + (state.qty === 2 ? SECOND_ADD : 0) + (state.box ? BOX_EACH * state.qty : 0);
    }

    function message() {
      var l4 = (window.mawjStrings && window.mawjStrings.l4) || {};
      var qtyText = state.qty === 2 ? (l4.qtyTwo || 'قطعتين') : (l4.qtyOne || 'قطعة وحدة');
      var shapePart = state.shape
        ? (l4.shapePart || ' — شكل {{ shape }}').replace('{{ shape }}', state.shape)
        : (l4.shapePartDefault || ' — نختار الشكل معكم');
      var boxPart = state.box ? (l4.boxPart || ' + علبة هدية فاخرة 🎁') : '';
      var totalLine = (l4.msgTotal || 'الإجمالي: {{ total }} د.إ شامل التوصيل 🚚').replace('{{ total }}', total());
      return [
        l4.msgGreeting || 'مرحبا 👋 أبغى أطلب من موج:',
        qtyText + ' ' + product + shapePart + boxPart,
        totalLine,
        '',
        l4.msgClosing || 'هذي صورتي، ممكن نبدأ الطلب؟ 🙏'
      ].join('\n');
    }

    var first = true;
    function bump(el) {
      if (!el) return;
      el.classList.remove('l4-bump');
      void el.offsetWidth; /* restart animation */
      el.classList.add('l4-bump');
    }
    function refresh() {
      var t = total();
      if (totalEl) totalEl.textContent = t;
      priceEls.forEach(function (p) { p.textContent = t; });
      if (!first) { bump(totalEl); priceEls.forEach(bump); }
      first = false;
      var href = 'https://wa.me/' + phone + '?text=' + encodeURIComponent(message());
      waLinks.forEach(function (a) {
        a.setAttribute('href', href);
        a.setAttribute('target', '_blank');
        a.setAttribute('rel', 'noopener');
      });
    }

    bundles.forEach(function (b) {
      b.addEventListener('click', function () {
        bundles.forEach(function (x) { x.classList.remove('is-on'); });
        b.classList.add('is-on');
        state.qty = parseInt(b.getAttribute('data-qty'), 10) || 1;
        refresh();
      });
    });

    shapes.forEach(function (s) {
      s.addEventListener('click', function () {
        shapes.forEach(function (x) { x.classList.remove('is-on'); });
        s.classList.add('is-on');
        state.shape = s.getAttribute('data-shape') || '';
        refresh();
      });
    });

    if (boxEl) {
      boxEl.addEventListener('click', function () {
        state.box = !state.box;
        boxEl.classList.toggle('is-on', state.box);
        boxEl.setAttribute('aria-pressed', state.box ? 'true' : 'false');
        refresh();
      });
    }

    refresh();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
